import { SVGProps, Ref, forwardRef } from 'react';

export const VkSquareBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M1 7.72c0-3.168 0-4.752.984-5.736S4.552 1 7.72 1h.56c3.168 0 4.752 0 5.736.984S15 4.552 15 7.72v.56c0 3.168 0 4.752-.984 5.736S11.448 15 8.28 15h-.56c-3.168 0-4.752 0-5.736-.984S1 11.448 1 8.28z"
                fill="#0077FF"
            />
            <path
                d="M8.45 11.086c-3.192 0-5.012-2.188-5.087-5.828H4.96c.052 2.672 1.23 3.804 2.164 4.037V5.258H8.63v2.304c.922-.099 1.89-1.149 2.217-2.304h1.505c-.251 1.424-1.301 2.474-2.048 2.905.747.35 1.943 1.266 2.398 2.923h-1.657C10.689 9.977 9.803 9.12 8.63 9.003v2.083z"
                fill="white"
            />
        </g>
    </svg>
));
VkSquareBrandSize16Glyph.displayName = 'VkSquareBrandSize16Glyph';
